/**
 * Converts ReadableStream to async iterable.
 *
 * Transforms Web Streams API ReadableStream into AsyncGenerator for iteration.
 * Properly releases reader lock on completion.
 *
 * @param stream - ReadableStream to convert (optional)
 * @returns AsyncGenerator yielding Uint8Array chunks
 *
 * @example
 * ```ts
 * import { StreamToIterable } from "@pdfking/tfunc"
 *
 * const response = await fetch("https://example.com/file")
 * for await (const chunk of StreamToIterable(response.body)) {
 *   console.log(`Received ${chunk.length} bytes`)
 * }
 * ```
 */
export const StreamToIterable = async function* (
  stream?: null | ReadableStream
): AsyncGenerator<Uint8Array> {
  if (!stream) return
  const reader = stream.getReader()
  try {
    while (true) {
      const { done, value } = await reader.read()
      if (done) break
      yield value
    }
  } finally {
    reader.releaseLock()
  }
}
